import * as React from 'react'
import Head from 'next/head'
import { IGarage, IMetaDataProps, IMetaTagItem } from 'shared-interfaces'
import { socialTags } from './socialTags'
import GlobalCtx, { IGlobalCtx } from '@/context/global'

const GarageSEO: React.FunctionComponent<{
    url?: string
    garageData?: IGarage
}> = (props) => {
    const globalCtx: IGlobalCtx = React.useContext(GlobalCtx)
    let garageData: IGarage | null | undefined = props.garageData
        ? props.garageData
        : globalCtx.garage

    let metaData: IMetaDataProps = garageData
        ? {
              url: `${props.url}`,
              title: `${
                  garageData && garageData.owner && garageData.owner.fullname
                      ? `${garageData.owner.fullname}'s `
                      : ''
              }Custodian Garage `,
              description:
                  garageData.owner && garageData.owner.bio
                      ? `${garageData.owner.fullname}'s Custodian Garage`
                      : '',
              image:
                  garageData.owner && garageData.owner.profile_image_url
                      ? garageData.owner.profile_image_url
                      : '',
              schemaType: 'ProfilePage',
              openGraphType: 'website',
          }
        : {
              url: `${props.url}`,
              title: 'garage',
              description: '',
              image: '',
              schemaType: 'ProfilePage',
              openGraphType: 'website',
          }

    return (
        <Head>
            <title>{metaData.title} | Custodian Link Share</title>
            <meta
                name="description"
                content={metaData.description ? metaData.description : ''}
            />
            <meta itemProp="name" content={metaData.title} />
            <meta
                itemProp="description"
                content={metaData.description ? metaData.description : ''}
            />
            <meta
                itemProp="image"
                content={metaData.image ? metaData.image : ''}
            />
            {socialTags(metaData).map((item: IMetaTagItem) => {
                if (item.type === 'twitter') {
                    return (
                        <meta
                            name={item.name}
                            content={item.content}
                            key={item.key}
                        />
                    )
                } else
                    return (
                        <meta
                            property={item.property}
                            content={item.content}
                            key={item.key}
                        />
                    )
            })}
            {garageData && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            '@context': 'http://schema.org',
                            '@type': 'ProfilePage',
                            name:
                                garageData.owner && garageData.owner.fullname
                                    ? garageData.owner.fullname
                                    : '',
                            about:
                                garageData.owner && garageData.owner.bio
                                    ? garageData.owner.bio
                                    : '',
                            url: `${props.url}`,
                            image:
                                garageData.owner &&
                                garageData.owner.profile_image_url
                                    ? garageData.owner.profile_image_url
                                    : '',
                        }),
                    }}
                />
            )}
        </Head>
    )
}

export default GarageSEO
